import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'

import { ModalCTA } from 'containers/misc'
import { Button, ButtonGroup } from 'components/misc'
import { Title } from 'components/layout'
import { Checkbox } from 'components/fields'
import { form } from 'helpers/decorators'

const enhance = compose(
  form({
    form: 'coordinator-settings'
  })
)

class CoordinatorSettings extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onMakeLeadCoordinator: PropTypes.func.isRequired,
    onRemoveCoordinator: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    contactId: PropTypes.number,
    submitting: PropTypes.bool,
    organizationId: PropTypes.number
  }

  state = {
    contactToRemoveId: null
  }

  handleRemoveCoordinator = contactToRemoveId => {
    this.setState({
      contactToRemoveId
    })
  }

  handleCancelRemoveCoordinator = () => {
    this.setState({
      contactToRemoveId: null
    })
  }

  render() {
    const { handleSubmit, organizationId, contactId, submitting } = this.props
    const { contactToRemoveId } = this.state

    return (
      <form
        onSubmit={handleSubmit(fields =>
          this.props.onMakeLeadCoordinator(contactId, organizationId, fields)
        )}
      >
        <Title
          h2
          className="text--center"
          intlKey="moduleTitle.coordinator_settings"
        >
          Coordinator settings
        </Title>
        <Checkbox label="Make as lead coordinator" intlKey="label.make_as_lead_coordinator" name="is_lead_coordinator" />
        <div className="row">
          <div className="col-xs-6">
            <ButtonGroup>
              <Button
                type="button"
                secondary
                onClick={this.props.onClose}
                intlKey="button.close"
              >
                Close
              </Button>
              <Button
                type="button"
                intlKey="button.remove"
                negative
                onClick={() => this.handleRemoveCoordinator(contactId)}
              >
                Remove
              </Button>
            </ButtonGroup>
          </div>
          <div className="col-xs-6 text--right">
            <Button intlKey="button.save_changes" isLoading={submitting}>
              Save changes
            </Button>
          </div>
        </div>
        {contactToRemoveId &&
          <ModalCTA>
            <Title h2 className="text--center">
              Remove coordinator?
            </Title>
            <div className="row">
              <div className="col-xs-6">
                <Button
                  type="button"
                  secondary
                  onClick={this.handleCancelRemoveCoordinator}
                  intlKey="button.cancel"
                >
                  Cancel
                </Button>
              </div>
              <div className="col-xs-6 text--right">
                <Button
                  type="button"
                  intlKey="button.remove"
                  negative
                  onClick={() =>
                    this.props.onRemoveCoordinator(
                      organizationId,
                      contactToRemoveId
                    )}
                >
                  Remove
                </Button>
              </div>
            </div>
          </ModalCTA>}
      </form>
    )
  }
}

export default enhance(CoordinatorSettings)
